import React from 'react';
import './project.scss';
import SEO from '../components/shared/seo';
import SingleProject from '../components/project/single-project/single-project';

var ProjectPage = function ProjectPage(_ref) {
  var _project$title, _project$title2, _project$tags, _project$client, _project$client2, _project$description, _project$description2, _project$slug;

  var data = _ref.data,
      pageContext = _ref.pageContext;
  console.log({
    data: data
  });
  var project = data.sanityProject; // selected project

  var language = pageContext.language; // For legible code

  var newProject = {
    title: language === 'en' ? (_project$title = project.title) === null || _project$title === void 0 ? void 0 : _project$title.en : (_project$title2 = project.title) === null || _project$title2 === void 0 ? void 0 : _project$title2.ja,
    publishedAt: new Date(project.publishedAt).getFullYear() + "." + (new Date(project.publishedAt).getMonth() + 1),
    tags: (_project$tags = project.tags) === null || _project$tags === void 0 ? void 0 : _project$tags.map(function (tag) {
      var _tag$title, _tag$title2;

      return language === 'en' ? tag === null || tag === void 0 ? void 0 : (_tag$title = tag.title) === null || _tag$title === void 0 ? void 0 : _tag$title.en : tag === null || tag === void 0 ? void 0 : (_tag$title2 = tag.title) === null || _tag$title2 === void 0 ? void 0 : _tag$title2.ja;
    }),
    client: language === 'en' ? (_project$client = project.client) === null || _project$client === void 0 ? void 0 : _project$client.en : (_project$client2 = project.client) === null || _project$client2 === void 0 ? void 0 : _project$client2.ja,
    tools: project.tools,
    url: project.url,
    videoUrl: project.videoUrl,
    description: language === 'en' ? (_project$description = project.description) === null || _project$description === void 0 ? void 0 : _project$description._rawEn : (_project$description2 = project.description) === null || _project$description2 === void 0 ? void 0 : _project$description2._rawJa,
    images: project.images,
    slug: (_project$slug = project.slug) === null || _project$slug === void 0 ? void 0 : _project$slug.current
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SEO, {
    title: newProject.title,
    lang: language
  }), /*#__PURE__*/React.createElement("div", {
    className: "project-page"
  }, /*#__PURE__*/React.createElement(SingleProject, {
    project: newProject
  })));
};

var query = "2547504134";
export default ProjectPage;